import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { DecorativeDivider, OmMark, CornerOrnament } from "@/components/Ornaments";

export default function PoojaList() {
  const { t } = useTranslation();
  const [poojas, setPoojas] = useState([]);

  useEffect(() => {
    api.get("/poojas").then(({ data }) => setPoojas(data));
  }, []);

  return (
    <div data-testid="poojas-list-page">
      {/* HEADER BAND */}
      <section className="section-tight bg-paper-strong relative overflow-hidden">
        <CornerOrnament corner="tr" element="yantra" />
        <div className="container-x relative text-center">
          <OmMark size={42} className="mx-auto text-[color:var(--brand)] mb-4" />
          <DecorativeDivider label={t("nav.poojas")} className="mb-5" />
          <h1 className="font-heading text-5xl md:text-7xl tracking-display leading-[0.98]">
            Our Sacred <em className="italic-serif text-[color:var(--brand)]">Poojas</em>
          </h1>
          <p className="mt-5 max-w-2xl mx-auto opacity-80">{t("poojas.subtitle")}</p>
        </div>
      </section>

      <section className="section bg-paper">
        <div className="container-x">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {poojas.map((p, idx) => (
              <Link
                key={p.slug}
                to={`/poojas/${p.slug}`}
                data-testid={`pooja-card-${p.slug}`}
                className="card-pooja rounded-md overflow-hidden p-3 flex flex-col group"
              >
                <div className="arch-mask aspect-[5/4] relative">
                  <img src={p.image_url} alt={p.name} className="w-full h-full object-cover" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#1a1514]/70 via-[#1a1514]/15 to-transparent" />
                  <div className="absolute top-3 left-3 w-9 h-9 rounded-full bg-[#faf8f5]/95 flex items-center justify-center font-heading italic-serif text-[color:var(--brand)]">
                    {String(idx + 1).padStart(2, "0")}
                  </div>
                  <div className="absolute inset-x-0 bottom-0 p-5 text-[#faf8f5]">
                    <h3 className="font-heading text-2xl leading-tight tracking-display">{p.name}</h3>
                  </div>
                </div>
                <div className="p-5 pt-6 flex-1 flex flex-col">
                  <p className="text-[14px] opacity-80 leading-relaxed line-clamp-3 flex-1">{p.short_description}</p>
                  <div className="gilt-rule my-5 w-16" />
                  <div className="flex items-end justify-between">
                    <div>
                      <div className="text-[10px] uppercase tracking-[0.22em] opacity-60">{t("poojas.startingFrom")}</div>
                      <div className="font-heading italic-serif text-3xl text-[color:var(--brand)] leading-none mt-1">
                        {t("common.rupee")}{p.price.toLocaleString("en-IN")}
                      </div>
                    </div>
                    <span className="inline-flex items-center gap-1 text-xs text-[color:var(--brand)]">
                      Explore <ArrowRight size={12} className="group-hover:translate-x-1 transition-transform" />
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
